import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";
import { useAuthenticationToken } from "./useAuthenticationToken";
import { useMemo } from "react";

export function useAccessible(
  rights?: AuthenticationAccessRight | AuthenticationAccessRight[],
  except?: AuthenticationAccessRight | AuthenticationAccessRight[],
): boolean {
  const authenticationToken = useAuthenticationToken();
  return useMemo(() => {
    if (!authenticationToken) {
      return false;
    }

    if (!rights) {
      return true;
    }

    if (!authenticationToken.canAccess(rights)) {
      return false;
    }

    if (except && authenticationToken.canAccess(except)) {
      return false;
    }

    return true;
  }, [rights, except, authenticationToken]);
}
